var PageList = require('../enum/PageList');

var Navigator = function(mainComponent) {
    this.requestAnalytics = id => {
        let newStateObj = {
            currentPage: PageList.analytics,
        };

        if (id && typeof id === 'string') {
            newStateObj.pageParameters = [id];
        }
        mainComponent.setState(newStateObj);
    };

    this.requestTestInstanceManagement = () => {
        mainComponent.setState({
            currentPage: PageList.testInstanceManagement,
            pageParameters: [],
        });
    };

    this.requestScenarioManagement = () => {
        mainComponent.setState({
            currentPage: PageList.scenarioManagement,
            pageParameters: [],
        });
    };

    this.requestDeviceManagement = () => {
        mainComponent.setState({
            currentPage: PageList.deviceManagement,
            pageParameters: [],
        });
    };

    this.requestEditDevice = id => {
        var newStateObj = { currentPage: PageList.editDevice };
        if (id && typeof id === 'string') newStateObj.pageParameters = [id];
        mainComponent.setState(newStateObj);
    };

    this.requestClusterManagement = () => {
        mainComponent.setState({
            currentPage: PageList.clusterManagement,
            pageParameters: [],
        });
    };

    this.requestCreateCluster = () => {
        mainComponent.setState({
            currentPage: PageList.createCluster,
            pageParameters: [],
        });
    };

    this.requestEditCluster = id => {
        var newStateObj = { currentPage: PageList.editCluster };
        if (id && typeof id === 'string') newStateObj.pageParameters = [id];
        mainComponent.setState(newStateObj);
    };

    this.requestAddNewTestInstance = () => {
        this.requestAddNewTestInstance(null);
    };

    this.requestAddNewTestInstance = cloneTestInstanceId => {
        var newStateObj = { currentPage: PageList.addNewTestInstance };
        if (cloneTestInstanceId && typeof cloneTestInstanceId === 'string') {
            newStateObj.pageParameters = [cloneTestInstanceId, "clone"];
        } else {
            newStateObj.pageParameters = null;
        }
        mainComponent.setState(newStateObj);
    };

    this.requestEditTestInstance = id => {
        var newStateObj = { currentPage: PageList.editTestInstance };
        if (id && typeof id === 'string') newStateObj.pageParameters = [id];
        mainComponent.setState(newStateObj);
    };

    this.requestHome = () => this.requestTestInstanceManagement();

    this.setPageParameters = parameters => {
        mainComponent.setState({ pageParameters: parameters });
    };

    this.requestAnalyticsPagination = () => {
        let newStateObj = {
            currentPage: PageList.analyticsTestInstanceList,
            pageParameters: [],
            compareOptions: {},
        };
        mainComponent.setState(newStateObj);
    };

    this.requestCompareTestInstances = (testInstanceIds, options) => {
        mainComponent.setState({
            currentPage: PageList.compareTestInstances,
            pageParameters: Array.isArray(testInstanceIds) ? testInstanceIds : [],
            compareOptions: options || {},
        });
    };

    this.requestMapAnalytics = id => {
        var newStateObj = { currentPage: PageList.mapAnalytics };
        if (id && typeof id === 'string') newStateObj.pageParameters = [id];
        mainComponent.setState(newStateObj);
    };

    this.requestMatrixAnalysis = id => {
        var newStateObj = { currentPage: PageList.matrixAnalysis };
        if (id && typeof id === 'string') newStateObj.pageParameters = [id];
        mainComponent.setState(newStateObj);
    };

    this.requestBatteryStats = id => {
        var newStateObj = { currentPage: PageList.batteryStats };
        if (id && typeof id === 'string') newStateObj.pageParameters = [id];
        mainComponent.setState(newStateObj);
    };

    this.requestAddNewScenario = () => {
        mainComponent.setState({
            currentPage: PageList.addNewScenario,
            pageParameters: [],
        });
    };

    this.requestEditScenario = id => {
        const newStateObj = { currentPage: PageList.editScenario };
        if (id && typeof id === 'string') newStateObj.pageParameters = [id];
        mainComponent.setState(newStateObj);
    };

    this.requestZonesImport = id => {
        const newStateObj = { currentPage: PageList.zonesImport };
        if (id && typeof id === 'string') newStateObj.pageParameters = [id];
        mainComponent.setState(newStateObj);
    };
    
    this.requestAddNewDevice = () => {
        mainComponent.setState({
            currentPage: PageList.addNewDevice,
            pageParameters: [],
        });
    };

    this.requestEditDeviceForm = id => {
        const newStateObj = { currentPage: PageList.editDevice }
        if (id && typeof id === 'string') newStateObj.pageParameters = [id]
        mainComponent.setState(newStateObj)
    }
};

module.exports = Navigator;
